import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import {
  mobileValidationSchema,
  verifyOTPValidationSchema,
} from "./ValidationSchema";

import Popup from "./Popup"

import { sendOtp, verifyOtp } from "../javaAxiosConfig";

import { useSearchParams } from "react-router-dom";

import Footer from "./Footer";
import Navbar from "./Navbar";
import { Button, TextField } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";

import heroImage from "../images/login-hero.png";
import callIcon from "../images/Phone_Call.png";

import { Bs123 } from "react-icons/bs";
import { MdPassword } from "react-icons/md";

export const LoginWithOtp = () => {
  const [step, setStep] = useState(1);
  const [resending, setResending] = useState(false);
  const [timer, setTimer] = useState(0);
  const [showPopup, setShowPopup] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");
  const [popupType, setPopupType] = useState("success"); // 'success' or 'error'
  const navigate = useNavigate();

  const [popupRedirect, setPopupRedirect] = useState(null);
// "login" | "register" | null


  const [searchParams] = useSearchParams();
  const mode = searchParams.get("mode"); // "register" or null
  const isRegisterMode = mode === "register";

  useEffect(() => {
  const pendingMobile = localStorage.getItem("pendingOtpMobile");
  const pendingType = localStorage.getItem("pendingOtpType");

  if (!pendingMobile || !pendingType) return;

  // Autofill mobile
  formik.setFieldValue("username", pendingMobile);

  // Auto-send OTP
  (async () => {
    try {
      await sendOtp({
        mobileNumber: pendingMobile,
        type: pendingType,
      });

      setStep(2);       // ✅ SHOW OTP INPUT
      setTimer(60);     // ✅ START TIMER
    } catch (e) {
      setPopupMessage("Failed to send OTP. Please try again.");
      setPopupType("error");
      setShowPopup(true);
    } finally {
      localStorage.removeItem("pendingOtpMobile");
      localStorage.removeItem("pendingOtpType");
    }
  })();
}, []);


useEffect(() => {
  // only reset if NO pending OTP
  if (!localStorage.getItem("pendingOtpMobile")) {
    formik.resetForm();
    setStep(1);
    setTimer(0);
  }
  setShowPopup(false);
}, [isRegisterMode]);



  const [isMobile, setIsMobile] = useState(window.innerWidth <= 500);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 500);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    let countdown;
    if (timer > 0) {
      countdown = setInterval(() => setTimer((prev) => prev - 1), 1000);
    }
    return () => clearInterval(countdown);
  }, [timer]);

  const formik = useFormik({
    initialValues: { username: "", otp: "" },
    validationSchema:
      step === 1 ? mobileValidationSchema : verifyOTPValidationSchema,
    onSubmit: async (values, { setSubmitting }) => {
      try {

        
if (step === 1) {
  const response = await sendOtp({
    mobileNumber: values.username,
    type: isRegisterMode ? "registration" : "login",
  });

  const { status, message, isRegistered } = response.data;

  // 🔹 CASE 1: OTP SENT (login OR valid registration)
  if (status === true) {
    setPopupMessage(message || "OTP sent successfully");
    setPopupType("success");
    setShowPopup(true);

    setStep(2);          // ✅ SHOW OTP INPUT
    setTimer(60);        // ✅ START TIMER
    return;
  }

  // 🔹 CASE 2: ALREADY REGISTERED (registration flow)
// 🔹 CASE 2: ALREADY REGISTERED → force LOGIN
if (status === false && isRegistered === true) {
  setPopupMessage(message || "You are already registered. Please login.");
  setPopupType("error");
  setPopupRedirect("login"); // 👈 IMPORTANT
  setShowPopup(true);
  return;
}


// 🔹 CASE 3: NOT REGISTERED → force REGISTER
if (status === false && isRegistered === false && !isRegisterMode) {
  setPopupMessage(message || "You are not registered. Please create an account.");
  setPopupType("error");
  setPopupRedirect("register"); // 👈 IMPORTANT
  setShowPopup(true);
  return;
}


  // 🔹 CASE 4: OTHER ERRORS
  setPopupMessage(message || "Failed to send OTP");
  setPopupType("error");
  setShowPopup(true);
}

        else if (step === 2) {


          const response = await verifyOtp({
            mobileNumber: values.username,
            otp: values.otp,
            firebaseToken: "dummy",
          });


          if (response.status === 200 && response.data?.status === true) {
            const progress = response.data.registrationProgress;

            localStorage.setItem("token", response.data.token);
localStorage.setItem("registrationProgress", progress);

// 🔥 CRITICAL: Persist resume data from submit-otp
console.group("[LOGIN OTP] submit-otp persistence");

console.log("API registerBy:", response.data.registerBy);
console.log("API gender:", response.data.gender);
console.log("API progress:", response.data.registrationProgress);

// registerBy (string)
if (response.data.registerBy) {
  localStorage.setItem("registerBy", response.data.registerBy);
}

// gender (single source of truth)
if (response.data.gender) {
  localStorage.setItem("gender", response.data.gender);
  localStorage.setItem("selectedGender", response.data.gender);
}

console.groupEnd();


// ✅ resumeMode ONLY for LOGIN
if (!isRegisterMode) {
  localStorage.setItem("resumeMode", "true");
  localStorage.setItem("loginType", "login");
} else {
  // 🔥 NORMAL REGISTRATION → CLEAR RESUME STATE
  localStorage.removeItem("resumeMode");
  localStorage.removeItem("loginType");
}
             
            setPopupMessage("OTP verified successfully");
            setPopupType("success");
            setShowPopup(true);

            setTimeout(() => {
              setShowPopup(false);

              if (
                progress === "COMPLETED" ||
                progress === "ABOUT_LIFE_PARTNER_CHECK" ||
                progress.includes("COMMUNITY")
              ) {
                navigate("/my_matches");
              } else {
                navigate("/register");
              }
            }, 500);
          } else {
            setPopupMessage(response.data.message);
            setPopupType("error");
            setShowPopup(true);

            formik.setFieldValue("otp", "");
          }
        }
      } catch (error) {
        setPopupMessage(
          error?.response?.data?.message || "Something went wrong!"
        );
        setPopupType("error");
        setShowPopup(true);
      } finally {
        setSubmitting(false);
      }
    },
  });

  const handleResendOtp = async () => {
    setResending(true);
    try {
      // const response = await getLoginWithOtp({
      //   username: formik.values.username,
      // });

      const response = 
      await sendOtp({
  mobileNumber: formik.values.username,
  type: isRegisterMode ? "registration" : "login",
});
      // await sendOtp(formik.values.username);

      
      

      if (response.status === 200) {
        setPopupMessage("OTP has been resent successfully.");
        setPopupType("success");
        setShowPopup(true);
        setTimer(60);
      } else {
        setPopupMessage(response.data.message);
        setPopupType("error");
        setShowPopup(true);
      }
    } catch {
      setPopupMessage("Failed to resend OTP.");
      setPopupType("error");
      setShowPopup(true);
    } finally {
      setResending(false);
    }
  };

  const inputStyle = {
    flex: 1,
    border: "none",
    outline: "none",
    background: "transparent",
    padding: "0 15px",
    fontSize: "16px",
    fontWeight: "500",
    color: "#333", // darker text color
    letterSpacing: "1px",
  };

  return (
    <>
      <div style={{ position: "relative", zIndex: 200 }}>
        <Navbar />
        <div
          style={{
            position: "fixed",
            top: "0",
            left: "0",
            width: "100%",
            height: "90px", // match Navbar height
            // boxShadow: "0 2px 10px rgba(0, 0, 0, 0.08)",
            pointerEvents: "none", // make it click-through
            zIndex: 99,
          }}
        ></div>
      </div>

      <div
        style={{
          width: "100%",
          height: "100%",
          minHeight: "55vh",
          background: "linear-gradient(180deg, #fff8f0 0%, #fff4ef 100%)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding: "120px 20px 60px",
          boxSizing: "border-box",
        }}
      >
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            alignItems: "stretch",
            width: "100%",
            maxWidth: "980px",
            background: "#fff",
            borderRadius: "20px",
            overflow: "hidden",
            boxShadow: "0 4px 15px rgba(0,0,0,0.08)",
          }}
        >
          {/* LEFT SIDE (Hero Section) */}
          <div
            style={{
              flex: isMobile ? "1 1 100%" : "0 0 480px",
              background: "#fff",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              color: "#fff",
              padding: isMobile ? "15px 10px" : "30px 20px 30px 10px",
              textAlign: "center",
              position: "relative",
            }}
          >
            <div
              style={{
                width: "100%",
                maxWidth: isMobile ? "280px" : "400px",
                minWidth: "150px",
                borderRadius: "16px",
                overflow: "hidden",
                position: "relative",
                boxShadow: isMobile ? "0 2px 10px rgba(0,0,0,0.05)" : "none",
              }}
            >
              <img
                src={heroImage}
                alt="Hero Couple"
                style={{
                  width: "100%",
                  height: isMobile ? "auto" : "auto",
                  objectFit: "cover",
                  borderRadius: "16px",
                  transform: isMobile ? "scale(0.95)" : "none",
                  transition: "transform 0.3s ease",
                }}
              />

              {/* Overlay text */}
              <div
                style={{
                  position: "absolute",
                  top: isMobile ? "10px" : "20px",
                  left: 0,
                  width: "100%",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: isMobile ? "start" : "start",
                  alignItems: "center",
                  textAlign: "center",
                  color: "#fff",
                  fontFamily: "Montserrat",
                  padding: isMobile ? "10px" : "20px",
                  // background: isMobile
                  //   ? "linear-gradient(180deg, rgba(0,0,0,0.4), rgba(0,0,0,0.4))"
                  //   : "transparent",
                }}
              >
                <h2
                  style={{
                    fontSize: isMobile ? "16px" : "22px",
                    fontWeight: 700,
                    marginBottom: isMobile ? "3px" : "5px",
                    lineHeight: isMobile ? "22px" : "26px",
                  }}
                >
                  Welcome to IND Matrimony
                </h2>
                <p
                  style={{
                    fontSize: isMobile ? "12px" : "14px",
                    opacity: 0.9,
                    marginBottom: isMobile ? "10px" : "20px",
                    lineHeight: isMobile ? "18px" : "22px",
                  }}
                >
                  We provide the best match making service
                </p>
              </div>
            </div>
          </div>

          {/* RIGHT SIDE (Form Section) */}
          <div
            style={{
              flex: "1 1 500px",
              padding: isMobile ? "20px 40px" : "50px 40px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {/* <h2
              style={{
                fontSize: "30px",
                fontWeight: 700,
                color: "#000",
                marginBottom: "20px",
                fontFamily: "Montserrat",
              }}
            >
              LOG
              <span
                style={{
                  background: "linear-gradient(180deg, #f78c25, #ff3c3c)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                }}
              >
                IN
              </span>
            </h2> */}

            <h2>{isRegisterMode ? "REGISTER" : "LOGIN"}</h2>

            {
              // Adding explicit event.preventDefault on form submit to avoid native reload
            }
            <form
              onSubmit={(event) => {
                event.preventDefault();
                formik.handleSubmit(event);
              }}
              style={{
                width: "100%",
                maxWidth: "420px",
                display: "flex",
                flexDirection: "column",
                gap: "20px",
              }}
            >
              {step === 1 ? (
                <>
                  <div style={{ width: "100%", maxWidth: "420px" }}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        borderRadius: "10px",
                        border: "1px solid #d4d4d4",
                        backgroundColor: "#f5fcfe",
                        height: "49px",
                        overflow: "hidden",
                        fontFamily: "Montserrat",
                      }}
                    >
                      {/* Left Icon Box */}
                      <div
                        style={{
                          width: "48px",
                          height: "100%",
                          backgroundColor: "#fff",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          borderRight: "1px solid #d4d4d4",
                        }}
                      >
                        <img
                          src={callIcon}
                          alt="Phone"
                          style={{ width: "22px", height: "22px" }}
                        />
                      </div>

                      <input
                        type="tel"
                        name="username"
                        placeholder="Mobile Number"
                        value={formik.values.username}
                        onChange={(e) => {
                          let val = e.target.value;

                          // Remove any non-digit characters
                          val = val.replace(/\D/g, "");

                          // Enforce max length of 10
                          if (val.length > 10) return;

                          // NEW: Allow only if empty OR starts with 6,7,8,9
                          if (val === "" || /^[6-9]/.test(val)) {
                            // Create a synthetic event for Formik
                            const syntheticEvent = {
                              ...e,
                              target: {
                                ...e.target,
                                name: "username",
                                value: val,
                              },
                            };
                            formik.handleChange(syntheticEvent);
                          }
                          // If it doesn't start with 6-9 (and not empty), do nothing → blocks invalid input
                        }}
                        onBlur={formik.handleBlur}
                        style={inputStyle}
                        autoComplete="tel"
                        inputMode="numeric"
                        pattern="[0-9]*"
                        maxLength={10}
                      />
                    </div>
                    {formik.touched.username && formik.errors.username && (
                      <p
                        style={{
                          color: "red",
                          fontSize: "13px",
                          marginTop: "5px",
                          fontFamily: "Montserrat",
                          marginRight: isMobile ? "0px" : "70px",
                        }}
                      >
                        {formik.errors.username}
                      </p>
                    )}
                  </div>

                

                  <Button
                    type="submit"
                    variant="contained"
                    disabled={formik.isSubmitting}
                    style={{
                      fontFamily: "Montserrat",
                      borderRadius: "50px",
                      background:
                        // "linear-gradient(90deg, #f78c25, #ff3c3c)",
                        "linear-gradient(rgba(255, 255, 255, 0.3), rgba(255, 255, 255, 0.22)), linear-gradient(90deg, #f78c25, #ff3c3c)",

                      color: "#fff",
                      fontWeight: 600,
                      fontSize: "16px",
                      height: "48px",
                      textTransform: "none",
                    }}
                  >
                    {step === 1
                      ? "Continue"
                      : isRegisterMode
                      ? "Verify & Register"
                      : "Verify & Login"}
                  </Button>
                </>
              ) : (
                <>
                  <div style={{ width: "100%", maxWidth: "420px" }}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        borderRadius: "10px",
                        border: "1px solid #d4d4d4",
                        backgroundColor: "#f5fcfe",
                        height: "49px",
                        overflow: "hidden",
                        opacity: 0.7,
                        fontFamily: "Montserrat",
                      }}
                    >
                      <div
                        style={{
                          width: "48px",
                          height: "100%",
                          backgroundColor: "#fff",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          borderRight: "1px solid #d4d4d4",
                        }}
                      >
                        <img
                          src={callIcon}
                          alt="Phone"
                          style={{ width: "22px", height: "22px" }}
                        />
                      </div>
                      <input
                        type="text"
                        name="username"
                        value={formik.values.username}
                        disabled
                        style={{
                          flex: 1,
                          border: "none",
                          outline: "none",
                          background: "transparent",
                          padding: "0 15px",
                          fontSize: "15px",
                          color: "rgba(79,79,79,0.6)",
                        }}
                      />
                    </div>
                  </div>

                  <div style={{ width: "100%", maxWidth: "420px" }}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        borderRadius: "10px",
                        border: "1px solid #d4d4d4",
                        backgroundColor: "#f5fcfe",
                        height: "49px",
                        overflow: "hidden",
                        fontFamily: "Montserrat",
                      }}
                    >
                      <div
                        style={{
                          width: "48px",
                          height: "100%",
                          backgroundColor: "#fff",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          borderRight: "1px solid #d4d4d4",
                        }}
                      >
                        {/* Define a gradient in SVG and use it in the icon */}
                        <svg width="0" height="0">
                          <linearGradient
                            id="otpGradient"
                            x1="0"
                            y1="0"
                            x2="1"
                            y2="0"
                          >
                            <stop offset="0%" stopColor="#f78c25" />
                            <stop offset="100%" stopColor="#ff3c3c" />
                          </linearGradient>
                        </svg>

                        <MdPassword
                          size={24}
                          style={{ fill: "url(#otpGradient)" }}
                        />
                      </div>

                      <input
                        type="text"
                        name="otp"
                        placeholder="Enter OTP"
                        value={formik.values.otp}
                        onChange={(e) => {
                          const val = e.target.value;

                          // ❌ Block everything except digits
                          if (!/^\d*$/.test(val)) return;

                          // ❌ Prevent typing more than 6 digits
                          if (val.length > 6) return;

                          formik.handleChange(e);
                        }}
                        onBlur={formik.handleBlur}
                        style={{
                          flex: 1,
                          border: "none",
                          outline: "none",
                          background: "transparent",
                          padding: "0 15px",
                          fontSize: "15px",
                          color: "rgba(79,79,79,0.94)",
                          letterSpacing: "2px",
                        }}
                      />
                    </div>
                    {formik.touched.otp && formik.errors.otp && (
                      <p
                        style={{
                          color: "red",
                          fontSize: "13px",
                          marginTop: "5px",
                          fontFamily: "Montserrat",
                          marginRight: isMobile ? "0px" : "140px",
                        }}
                      >
                        {formik.errors.otp}
                      </p>
                    )}
                  </div>

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      fontSize: "14px",
                    }}
                  >
                    <p style={{ color: "#555", fontFamily: "Montserrat" }}>
                      Didn’t receive OTP?
                    </p>
                    <p
                      onClick={timer === 0 ? handleResendOtp : null}
                      style={{
                        cursor: timer === 0 ? "pointer" : "not-allowed",
                        color: timer === 0 ? "#ff3c3c" : "grey",
                        fontWeight: 600,
                        fontFamily: "Montserrat",
                      }}
                    >
                      {timer > 0 ? `Resend OTP in ${timer}s` : "Resend OTP"}
                    </p>
                  </div>
                  <Button
                    type="submit"
                    variant="contained"
                    disabled={formik.isSubmitting}
                    style={{
                      borderRadius: "50px",
                      background:
                        // "linear-gradient(90deg, #f78c25, #ff3c3c)",
                        "linear-gradient(rgba(255, 255, 255, 0.3), rgba(255, 255, 255, 0.22)), linear-gradient(90deg, #f78c25, #ff3c3c)",

                      color: "#fff",
                      fontWeight: 600,
                      fontSize: "16px",
                      height: "48px",
                      textTransform: "none",
                      fontFamily: "Montserrat",
                    }}
                  >
                    Confirm
                  </Button>
                </>
              )}
            </form>


            {/* Only show "Not a Member? Create Account" when NOT in register mode */}
            {!isRegisterMode && (
              <p
                style={{
                  marginTop: "25px",
                  fontSize: "15px",
                  color: "#555",
                  fontFamily: "Montserrat",
                }}
              >
                Not a Member?{" "}
                <Link
                  to="/otpLogin?mode=register"
                  style={{
                    background:
                      "linear-gradient(90deg, rgba(255,119,5,0.88), rgba(230,0,0,0.81))",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                    fontWeight: 600,
                    textDecoration: "none",
                  }}
                >
                  Create Account
                </Link>
              </p>
            )}
          </div>
        </div>
      </div>
      {/* <ToastContainer /> */}
      <Footer />

      {/* Popup Modal */}
      {showPopup && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
          }}
          onClick={() => setShowPopup(false)}
        >
          <div
            style={{
              backgroundColor: "#fff",
              borderRadius: "10px",
              padding: "20px",
              maxWidth: "400px",
              width: "90%",
              textAlign: "center",
              boxShadow: "0 4px 15px rgba(0,0,0,0.2)",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <div
              style={{
                fontSize: "48px",
                marginBottom: "10px",
                color: popupType === "success" ? "#28a745" : "#dc3545",
              }}
            >
              {popupType === "success" ? "✓" : "✕"}
            </div>
            <h3
              style={{
                margin: "0 0 10px 0",
                color: popupType === "success" ? "#28a745" : "#dc3545",
                fontFamily: "Montserrat",
                fontSize: "18px",
                fontWeight: "600",
              }}
            >
              {popupType === "success" ? "Success" : "Error"}
            </h3>
            <p
              style={{
                margin: "0 0 20px 0",
                color: "#333",
                fontFamily: "Montserrat",
                fontSize: "14px",
                lineHeight: "1.5",
              }}
            >
              {popupMessage}
            </p>

            <button

              // onClick={() => {
              //   // If it's an error on OTP step, clear only the OTP field
              //   if (popupType === "error" && step === 2) {
              //     formik.setFieldValue("otp", "");
              //     formik.setFieldTouched("otp", false);
              //   }
              //   setShowPopup(false);
              // }}

                onClick={() => {
    setShowPopup(false);

    // 🔁 REDIRECTION BASED ON POPUP INTENT
if (popupRedirect === "login") {
  localStorage.setItem("pendingOtpMobile", formik.values.username);
  localStorage.setItem("pendingOtpType", "login");
  navigate("/otpLogin");
  return;
}

if (popupRedirect === "register") {
  localStorage.setItem("pendingOtpMobile", formik.values.username);
  localStorage.setItem("pendingOtpType", "registration");
  navigate("/otpLogin?mode=register");
  return;
}


    // 🔁 OTP error → clear OTP only
    if (popupType === "error" && step === 2) {
      formik.setFieldValue("otp", "");
      formik.setFieldTouched("otp", false);
    }

    setPopupRedirect(null);
  }}

              style={{
                backgroundColor:
                  popupType === "success" ? "#28a745" : "#dc3545",
                color: "#fff",
                border: "none",
                borderRadius: "5px",
                padding: "10px 20px",
                cursor: "pointer",
                fontFamily: "Montserrat",
                fontSize: "14px",
                fontWeight: "600",
              }}
            >
              OK
            </button>
          </div>
        </div>
      )}

{/* <Popup
  open={showPopup}
  type={popupType}
  message={popupMessage}
  onClose={() => setShowPopup(false)}
  primaryAction={() => {
    // Clear OTP only on error in step 2
    if (popupType === "error" && step === 2) {
      formik.setFieldValue("otp", "");
      formik.setFieldTouched("otp", false);
    }
  }}
/> */}


      <style>
        {`
  .custom-input::placeholder {
    color: rgba(79, 79, 79, 0.55); /* light placeholder */
    fontWeight: "normal",
  }
`}
      </style>
    </>
  );
};
